import React, { useState, useEffect } from 'react';
import './ModiFyRegistrationDetails.css'
import Form from 'react-bootstrap/Form';
import InfoPopover from '../Common/InfoPopover';
import ProjectsService from '../../Services/ProjectsService';
import PhoneInput, {
  isValidPhoneNumber
} from 'react-phone-number-input';

import 'react-phone-number-input/style.css';
import ServiceRequestModel from './ServiceRequestModel';
import OtpInputModal from '../Company/OtpInputModal';
import SRQService from '../../Services/SRQService';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

const AddNewAccountableRepresentative = ({ onCancel }) => {

  const [isCreateSRQButtonActive, setIsCreateSRQButtonActive] = useState(false);
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const [OtpDataFromModal, setOtpDataFromModal] = useState([]);

  const [modalShow, setModalShow] = React.useState(false);
  var otpInputModelOpenendForAction = '';

  const [selectedRequestTypeCompany, setSelectedRequestTypeCompany] = useState('');
  const [existingCompany, setExistingCompany] = useState([]);

  const [accountCountryCode, setAccountCountryCode] = useState("");
  const [accountAdditionalDetails, setAccountAdditionalDetails] = useState("");

  const [accountCheck, setAccountCheck] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);

  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");

  const [message, setMessage] = useState(" ");

  const [responseMessage, setResponseMessage] = useState(" ");
  const [representativePhoneNumber, setRepresentativePhoneNumber] = useState('')

  function handleEmail(event) {
    let inputValue = event.target.value;
    setEmail(inputValue);
    let emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (!emailRegex.test(inputValue)) {
      setMessage("Email Id is invalid");
    } else {
      setMessage("");
    }
  }
  const handleDisplayName = (event) => {
    let eValue = event.target.value;
    setDisplayName(eValue);
  }


  const handleAccountCheckBox = (event) => {
    let isChecked = event.target.checked;
    if (isChecked)
      setDisplayName("");
    setAccountCheck(isChecked);
  }



  const handleSelectChange = (event) => {
    let eValue = event.target.value;
    setSelectedRequestTypeCompany(eValue);
    if (eValue == "Select Existing Company") {
      setDisplayName("");
      setEmail("");
      setAccountAdditionalDetails("");
      setRepresentativePhoneNumber("")
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }
  const onServiceRequestCreated = () => {
    console.log("inside onServiceRequestCreated function")
    clearAllFields();
    setModalShow(false);
    window.location.href = "/viewserviceRequests";
  };
  function clearAllFields() {

  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        backdrop='static'
        keyboard="False"
        dialogClassName='my-modal'



      >
        <Modal.Header className='modal-header'>
          <Modal.Title id="contained-modal-title-vcenter">
            Confirmation on  service request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <p>
            {responseMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="ui button comm-button-style primary" onClick={onServiceRequestCreated}>OK</button>
        </Modal.Footer>
      </Modal>
    );
  }


  async function createSRQ() {
    console.log("HI FROM Creeate company")
    if (
      !accountCheck &&
      !isValidPhoneNumber(representativePhoneNumber)
    ) {
      toast.error('Please enter a valid phone number');
      return;
    }

    //e.preventDefault();
    setIsCreateSRQButtonActive(true);


    otpInputModelOpenendForAction = "registerCompany";
    setOtpModalOpen(true);

    // 
    try {
      const response = await ProjectsService.getStrongConfirmationCode("POST", null, "registerCompany", null, null, null);
      if (response && response.data.channel == "SMS") {
        otpInputModelOpenendForAction = "registerCompany";


        setOtpModalOpen(true);
      }


    } catch (error) {
      console.log(error);
    }
    // setModalShow(true);  //enable here for modal testing

  }

  const resendOtp = async () => {
    await ProjectsService.getStrongConfirmationCode("POST", null, "registerCompany", null, null, null);
  }

  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  }

  async function verifyOtp(OtpDataFromModal) {

    if (OtpDataFromModal.length !== 0) {

      console.log(OtpDataFromModal)
      OtpDataFromModal = Number(OtpDataFromModal.join(''));
      //alert("otp:"+OtpDataFromModal)
      ServiceRequestModel.companyId = selectedRequestTypeCompany;
      // ServiceRequestModel.projectId=null;
      ServiceRequestModel.requestType = "AddCRep";
      ServiceRequestModel.requestText = accountAdditionalDetails.replace(/(?:\r\n|\r|\n)/g, ' ');
      ServiceRequestModel.subjectNewUser.displayName = displayName;
      ServiceRequestModel.subjectNewUser.email = email;
      ServiceRequestModel.subjectNewUser.mobile = representativePhoneNumber;
      // ServiceRequestModel.subjectCompany.name=newCompanyName;

      console.log(ServiceRequestModel);


      // alert("userDetailsObject.password"+userDetailsObject.password);

      const response = await SRQService.createNewServiceRequest(ServiceRequestModel, OtpDataFromModal)
        .then((response) => {
          setResponseMessage(response.data.message);
          setModalShow(true);
          setOtpModalOpen(false);
        }).catch(error => {
          // Check if it's an APIM error - let global interceptor handle those
          if (error.response?.data?.code?.startsWith('APIM-')) {
            console.log('APIM error, letting global interceptor handle it');
          } else {
            toast.error(error.response.data.message, {

              position: toast.POSITION.BOTTOM_RIGHT,

              autoClose: 8000, //6 seconds

              hideProgressBar: false,

              closeOnClick: true,

              pauseOnHover: true,

              draggable: true,

            });
          }
          console.log(error);
        });

    }

  }

  const handleClearCompanySelection = () => {
    setSelectedRequestTypeCompany("");
    setDisplayName("");
    setEmail("");
    setAccountAdditionalDetails("");
    setRepresentativePhoneNumber("")
  };

  useEffect(() => {
    ProjectsService.getAllProjects().then((response) => {
      setExistingCompany(response.data[0].companyProjects);
    }).catch(error => {
      console.log(error);
    });
  }, [])

  const customstyles = {
    dropdownindicator: base => ({
      ...base,
      fill: "red" // custom colour
    })
  };


  const handleCancel = () => {
    clearAllFields();

    if (onCancel) {
      onCancel();
    }
  }



  // Removed legacy popover helper (InfoPopover handles display)

  const renderEmailbox = () => {
    return (
      <>
        <li>
          <div className="custom-input-wrapp mb-4">
            <input
              type="text"
              className="inputText"
              tabIndex={1}
              required=""
              id="inputEmailCrep"
              placeholder="Email Id"
              maxLength={256}
              disabled={isDisabled || !selectedRequestTypeCompany}
              value={email}
              onChange={e => handleEmail(e)}
            />
            <span className="input-info-label ms-0">Eg: username@domain.com</span>
            <span className="required-field-op">(Required)</span>
            <div style={{ color: "red" }}> {message} </div>
          </div>
        </li>
      </>
    )
  }

  return (
    <>
      <li>
        <div className="sec">
          <div className="head-titlw-w head-titl-unset">
            <h3
              style={{ fontSize: "16px" }}
              className="sec-title"
              id="ManageCompany-ModifyCompany-promptForModifyCompany"
              data-info=""
            >
              ADD NEW ACCOUNTABLE REPRESENTATIVE.
            </h3>
          </div>
          <ul className="serv-req sec-inner-wrap">
            <li>
              <div
                className="dropdown-w-info mt-3"
                id="selectModifyCompanyWrapper"
                style={{ display: "flex", position: 'relative' }}
              >
                {selectedRequestTypeCompany ? (

                  <span
                    id='clear-icon-AddAccRep-company'
                    className="clear-icon-AddAccRep-company no-ligatures"
                    onClick={handleClearCompanySelection}
                  >
                    &times;
                  </span>

                ) : (
                  <i className="dropdown icon" />
                )}
                <div className="width-full">
                  <Form.Select
                    defaultValue="Select Existing Company"
                    value={selectedRequestTypeCompany}
                    onChange={handleSelectChange}
                    styles={customstyles}
                    style={{ width: "100%" }}
                    className={selectedRequestTypeCompany ? 'dropdown-with-close' : 'dropdown-default'}
                  >
                    <option className="textdefault">
                      {"Select Existing Company"}
                    </option>

                    {existingCompany &&
                      existingCompany.map((cp) => {
                        //alert(cp.name);
                        return <option value={cp.id}>{cp.name}</option>;
                      })}
                  </Form.Select>

                  <span className="required-field-op">(Required)</span>
                </div>
                <InfoPopover
                  id="infoPopOverModifyCompany"
                  className="info-icon-w ms-2"
                  content={"Please select the company to be represented."}
                  ariaLabel="Information: select the company to be represented"
                />
              </div>
            </li>

            <>
              <div className="awesome">
                <ul className="serv-req sec-inner-wrap">
                  <li className="user-exist-w">
                    <div className="form-check mb-3">
                      <label className="form-check-label">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="remember"
                          onChange={(e) => handleAccountCheckBox(e)}
                          defaultChecked={accountCheck}
                          disabled={isDisabled}
                        />{" "}
                        User already exist
                      </label>
                    </div>
                  </li>

                  {accountCheck && accountCheck ? (
                    <>{renderEmailbox()}</>
                  ) : (
                    <>
                      <li id="inputDisplayNameCrepWrapper" style={{}}>
                        <div className="custom-input-wrapp mb-4">
                          <input
                            type="text"
                            className="inputText"
                            required=""
                            maxLength={240}
                            tabIndex={1}
                            id="inputDisplayNameCrep"
                            placeholder="Display Name"
                            disabled={isDisabled || !selectedRequestTypeCompany}
                            value={displayName}
                            onChange={e => handleDisplayName(e)}
                          />
                          <span className="input-info-label">
                            Eg: Username
                          </span>
                          <span className="required-field-op">
                            (Required)
                          </span>
                          <span
                            className="form-error error-message-show"
                            style={{ visibility: "hidden" }}
                          >
                            Display Name is invalid
                          </span>
                        </div>
                      </li>
                      {renderEmailbox()}
                      <li
                        className="select-drop-message"
                        id="inputMobileNoCrepWrapper"
                        style={{}}
                      >
                        <div className="contact-num-wrap">
                          <div className="country-code-w">
                            <div className="phone-input-wrapper">
  <PhoneInput
    international
    value={representativePhoneNumber}
    onChange={(value) => {
      setRepresentativePhoneNumber(value || '');
    }}
    placeholder="Enter phone number"
    disabled={isDisabled}
  />
</div>

                          </div>
                          <span className="required-field-op">(Required)</span>

                        </div>
                      </li>
                    </>
                  )}

                  <li>
                    <div className="custom-input-wrapp mt-3 mb-3">
                      <div className="dropdown-w-info">
                        <div className="width-full">
                          <textarea
                            className="cust-text-a"
                            maxLength={4000}
                            placeholder="Additional Details"
                            id="textAreaModifyAdditionalDetails"
                            tabIndex={1}
                            value={accountAdditionalDetails}
                            onChange={(e) =>
                              setAccountAdditionalDetails(e.target.value)
                            }
                            disabled={!selectedRequestTypeCompany || selectedRequestTypeCompany === ""}
                          />
                        </div>
                        <InfoPopover
                          id="infoPopOverModifyAdditionalDetails"
                          className="info-icon-w pop-common-sel sr-pophover visible ms-2"
                          content={"Please provide reason for change and any additional information relevant to the registration process here."}
                          ariaLabel="Information: additional details guidance"
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </>
          </ul>
        </div>
      </li>
      <li className="apim-pop-button-w comm-button-wrap ser-req-btn">
        {(!isCreateSRQButtonActive && ((!accountCheck && email && displayName && isValidPhoneNumber(representativePhoneNumber)) || (accountCheck && email))) ?
          <button
            className="comm-button-style primary btn-disable"
            tabIndex={1}
            onClick={() => createSRQ()}
          >
            Create
          </button> :
          <button className="button comm-button-style primary btn-disable" id="btnSubmitRegisterCompany" tabindex="1"
            disabled>{!isCreateSRQButtonActive ? <>Create</> : <>Creating Service Request..</>}</button>
        }
        <button
          type="button"
          className="button comm-button-style secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </li>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      {/* ✅ Using global ToastContainer from App.js - removed local instance */}
      {OtpModalOpen && <OtpInputModal ModalHeading={""} setOpenOtpModal={setOtpModalOpen} handleOtp={handleOtp} value={OtpDataFromModal} verifyOtp={verifyOtp} credentialRecord={""} otpInputModelOpenendForAction={otpInputModelOpenendForAction} resendOtp={resendOtp} />}

    </>
  );
}
export default AddNewAccountableRepresentative;